import { render, staticRenderFns } from "./plan-box.vue?vue&type=template&id=59d7226c&scoped=true"
import script from "./plan-box.vue?vue&type=script&lang=js"
export * from "./plan-box.vue?vue&type=script&lang=js"
import style0 from "./plan-box.vue?vue&type=style&index=0&id=59d7226c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d7226c",
  null
  
)

export default component.exports